module.exports = __webpack_public_path__ + "img/ActForex-tab-icon.fddd0984.png";